import {
  CitiesResponse,
  CityPlanesResponse,
  PlanResponse,
} from "./types";

/** In dev, use same-origin paths so CRA's `proxy` avoids browser CORS blocks. */
const API_BASE_URL =
  process.env.REACT_APP_CHISME_PUBLIC_API_BASE_URL ??
  (process.env.NODE_ENV === "development"
    ? ""
    : "https://europe-west1-chisme-prod.cloudfunctions.net/publicWebApi");

const NORMALIZED_API_BASE_URL = API_BASE_URL.endsWith("/")
  ? API_BASE_URL.slice(0, -1)
  : API_BASE_URL;

async function fetchJson<T>(path: string): Promise<T> {
  const response = await fetch(`${NORMALIZED_API_BASE_URL}${path}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error(`API request failed (${response.status})`);
    (error as Error & {status?: number}).status = response.status;
    throw error;
  }

  return await response.json() as T;
}

export async function getCities(): Promise<CitiesResponse> {
  return await fetchJson<CitiesResponse>("/v1/cities");
}

export async function getCityPlanes(citySlug: string): Promise<CityPlanesResponse> {
  return await fetchJson<CityPlanesResponse>(`/v1/cities/${citySlug}/planes`);
}

export async function getPlanBySlug(planSlug: string): Promise<PlanResponse> {
  return await fetchJson<PlanResponse>(`/v1/plans/${planSlug}`);
}
